<template>
  <div
    class="dropdown"
    :class="{'is-active': isActive, 'is-right': config.position === 'right'}"
    @mouseleave="config.isHover ? close() : ()=>{}"
  >
    <div v-if="!config.isHover" class="dropdown-trigger" @click="isActive ? close(): open()">
      <slot name="trigger"></slot>
    </div>
    <div v-if="config.isHover" class="dropdown-trigger" @mouseover="open()">
      <slot name="trigger"></slot>
    </div>
    <div class="dropdown-menu" id="dropdown-menu" role="menu" @click="close()">
      <div class="dropdown-content">
        <slot></slot>
      </div>
    </div>
    <div class="dropdown-overlay" v-if="!config.isHover && isActive" @click="close()"></div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

import { IDropdown } from './';

@Component({
  name: 'Dropdown'
})
class Dropdown extends Vue {
  @Prop() public config!: IDropdown;
  public isActive = false; public openClick = true;
  public created() {
    this.isActive = this.config.isActive ? true : false;

    if (this.config.isActive === undefined) {
      this.config.isActive = false;
    }
  }
  public open() {
    this.isActive = true;
  }

  public close() {
    this.openClick = false;

    if (this.config.close) {
      this.config.close();
    } else {
      if (this.config.onClose) {
        this.config.onClose();
      }

      this.isActive = false;
    }
  }
}

export default Dropdown;
</script>
<style lang="scss">
@import "./src/bulma/components/dropdown";
.dropdown-overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 4rem;
  z-index: 1;
}
</style>